import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';
import React from 'react';
import typographyGenerator from './generator';
import { IBaseTypography, lineHeights, textStyles } from './types';

interface ITextProps extends IBaseTypography {
	htmlElement?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
	children: any;
}

const Wrapper: React.FC<ITextProps> = ({ children, type, lineHeight, className, htmlElement }) => {
	const Text = styled[htmlElement ?? 'h2']<{type: textStyles, lineHeight: lineHeights}>`
		${((props) => typographyGenerator(props.type, props.lineHeight, theme))}
	`;

	return <Text type={type} lineHeight={lineHeight} className={className}>{children}</Text>;
};

export default Wrapper;
